import { showSuccess } from '@calendly/alert'
import { useFormField } from '@calendly/form'
import { useOnValueChange } from '@calendly/hooks'
import { I18n } from '@calendly/i18n'
import { useDispatch } from 'react-redux'

import { getDateOverrides } from 'components/event_type_edit/utils/get_availability_from_rule'
import { useApplyAvailabilityToEventTypesMutation } from 'features/event_type_editor/api'
import { useLazyFetchEventTypeQuery } from 'features/event_type_provider'
import { getDefaultDays } from 'selectors/availability/schedules'

export const useApplyTo = ({ toggleDropdown, selectedETs }) => {
  const dispatch = useDispatch()
  const [applyAvailabilityToEventTypes, { isSuccess, isLoading }] = useApplyAvailabilityToEventTypesMutation()

  useOnValueChange(isSuccess, () => {
    if (isSuccess) {
      dispatch(showSuccess(I18n.t(
        'publisher.event_type_editor.sections.availability.schedule.actions.copy_from_to.copy_to_success',
        { count: selectedETs.length }
      )))
      toggleDropdown()
    }
  })

  return { apply: applyAvailabilityToEventTypes, isLoading }
}

export const useCopyFrom = ({ toggleDropdown, userId }) => {
  const [{ value: etmAttrs }, _, { setValue: setETMAttrs }] = useFormField({ name: 'event_type_memberships_attributes' })

  const [fetchEventType, { data: fullEtToCopy, isFetching: isCopyLoading, isSuccess: isCopySuccess }] = useLazyFetchEventTypeQuery()

  const copyFromEventType = (eventTypeToCopy) => {
    fetchEventType(eventTypeToCopy)
  }

  useOnValueChange(isCopyLoading, () => {
    if (isCopySuccess && !isCopyLoading) {
      const eventTypeMembershipData = etmAttrs.find(({ userId: etmUserId }) => userId === etmUserId)
      const memberToCopyFrom = fullEtToCopy.memberships.find(({ user_id: mUserId }) => userId === mUserId)

      if (!(eventTypeMembershipData || memberToCopyFrom) || fullEtToCopy.active_availability_rule_id) {
        toggleDropdown()

        return
      }

      const ownerAvailabilityRules = eventTypeMembershipData.ownerAvailabilityRules?.rules || []

      const {
        active_availability_rule_id: activeRuleId,
        own_availability_rule: ownRule
      } = memberToCopyFrom

      if (!activeRuleId) { return }

      const isOwnRule = ownRule?.id === activeRuleId
      const activeRule = isOwnRule ? ownRule : ownerAvailabilityRules.find(({ id }) => id === activeRuleId)

      if (!activeRule) { return }
      setETMAttrs(etmAttrs.map((attrs) => {
        if (attrs.userId === userId) {
          return {
            ...attrs,
            availableHours: getDefaultDays(activeRule.rules),
            dateOverrides: getDateOverrides(activeRule),
            usingCustomHours: isOwnRule,
            usingSecondarySchedule: !isOwnRule,
            timezone: activeRule.timezone,
            activeAvailabilityRuleId: activeRuleId
          }
        }

        return attrs
      }))

      toggleDropdown()
    }
  })

  return { copyFromEventType, isLoading: isCopyLoading }
}
